// extracted by mini-css-extract-plugin
export default {"Settingcontainer":"Settings_Settingcontainer__Yf2GX","AddAdmin":"Settings_AddAdmin__f+Bil"};